<div class="flex flex-col h-full">
    <h1 class="text-center mt-0">{{ currentDateRangeText }}</h1>

    <div class="flex-grow overflow-hidden">
        <full-calendar #fullCalendar [options]="calendarOptions" class="h-full"></full-calendar>
    </div>

    <div class="dropdown-menu fc-settings" [style.display]="showFcSettingsMenu ? 'block' : 'none'">
        <li>
            <h6 class="dropdown-header">{{ 'txScheduler.calendarView' | translate }}</h6>
        </li>
        <li>
            <a class="dropdown-item" [routerLink]=""
               (click)="changeView('timeGridDay')">{{ 'txScheduler.day' | translate }}</a>
        </li>
        <li>
            <a class="dropdown-item" [routerLink]="" (click)="changeView('timeGridThreeDays')">{{
                    'txScheduler.3days' | translate
                }}</a>
        </li>
        <li>
            <a class="dropdown-item" [routerLink]="" (click)="changeView('timeGridWorkday')">{{
                    'txScheduler.workday' | translate
                }}</a>
        </li>
        <li>
            <a class="dropdown-item" [routerLink]="" (click)="changeView('timeGridWeek')">{{
                    'txScheduler.week' | translate
                }}</a>
        </li>
        <li>
            <a class="dropdown-item" [routerLink]="" (click)="changeView('dayGridMonth')">{{
                    'txScheduler.month' | translate
                }}</a>
        </li>
        <li class="dropdown-divider"></li>
        <li>
            <h6 class="dropdown-header">{{ 'txScheduler.intervalView' | translate }}</h6>
        </li>
        <li>
            <a class="dropdown-item" [routerLink]=""
               (click)="toggleSlotMode()">{{ 'txScheduler.intervalMode' | translate }}</a>
        </li>
    </div>
</div>
